import { QuestionsSection } from "shared/QuestionsSection";
import { useProductPageContext } from "shared/product/ProductPageContext/useProductPageContext";

export const RentalQuestions = () => {
  const {
    family: { modelName },
  } = useProductPageContext();

  return <QuestionsSection productName={modelName} />;
};
